/*
 * Crafting A-Z — video facade
 *
 * Replaces the poster with the real embed on the first press, and autoplays it
 * so the press that loaded the player is also the press that started the video.
 * Nothing loads before that, which is the whole point of the facade — see the
 * snippet's header for why.
 *
 * The provider id and type come from Shopify's `video_url` setting, so the URL
 * has already been parsed and validated by the platform; this file only builds
 * the embed address.
 */
(function () {
  'use strict';

  function embedSrc(type, id) {
    if (type === 'youtube') {
      return (
        'https://www.youtube.com/embed/' +
        encodeURIComponent(id) +
        '?autoplay=1&rel=0&playsinline=1'
      );
    }

    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    }

    return null;
  }

  function play(button) {
    var id = button.dataset.chVideoId;
    var type = button.dataset.chVideoType;
    var src = embedSrc(type, id);
    if (!src) return;

    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = button.getAttribute('aria-label') || 'Video';
    frame.loading = 'lazy';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    frame.className = 'ch-video__frame';

    button.replaceWith(frame);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-ch-video]') : null;
    if (button) play(button);
  });
})();
